/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // Splash de entrada removido — ocultado imediatamente sem bloquear scroll.
        (function () {
          var el = document.getElementById('site-splash');
          if (el) { el.hidden = true; }
          document.documentElement.classList.add('no-site-splash');
        }());

        // ---- Serviços: toggle card aberto/fechado (animado) ----
        (function () {
          var dataEl = document.getElementById('sv-data');
          if (!dataEl) return;

          var services   = JSON.parse(dataEl.textContent || '[]');
          var grid       = document.getElementById('sv-grid');
          var openView   = document.getElementById('sv-open');
          var panel      = document.getElementById('sv-panel');
          var panelTitle = document.getElementById('sv-panel-title');
          var panelBody  = document.getElementById('sv-panel-body');
          var panelImg   = document.getElementById('sv-panel-img');
          var panelImage = document.getElementById('sv-panel-image');
          var miniCol    = document.getElementById('sv-mini-col');
          var closeBtn   = document.getElementById('sv-panel-close');

          var DURATION = 380; // deve coincidir com $sv-duration
          var currentIdx  = -1;
          var isAnimating = false;

          var colorMap = {
            areia:   '#E5E2C1',
            verde:   '#27AA87',
            laranja: '#FF522A',
            amarelo: '#FFE445'
          };

          // Preenche o conteúdo do painel expandido
          function fillPanel(idx) {
            var s = services[idx];
            if (!s) return;

            panelTitle.textContent = s.title || '';
            panelBody.innerHTML    = s.description || '';
            panel.style.background = colorMap[s.color] || colorMap.areia;

            if (s.image) {
              panelImg.src           = s.image;
              panelImg.alt           = s.image_alt || '';
              panelImage.style.display = '';
            } else {
              panelImg.src           = '';
              panelImage.style.display = 'none';
            }

            // Mini-cards: os outros 3
            miniCol.innerHTML = '';
            services.forEach(function (other, i) {
              if (i === idx) return;
              var btn = document.createElement('button');
              btn.className = 'service-card sc--' + other.color;
              btn.type = 'button';
              btn.setAttribute('data-service', i);
              btn.innerHTML =
                '<div class="sc-main">' +
                  '<h3 class="sc-title">' + (other.title || '') + '</h3>' +
                  '<span class="sc-plus" aria-hidden="true">+</span>' +
                '</div>' +
                (other.icon ? '<img class="sc-icon" src="' + other.icon + '" alt="">' : '');
              btn.addEventListener('click', function () { handleCardClick(i); });
              miniCol.appendChild(btn);
            });

            currentIdx = idx;
            document.querySelectorAll('#sv-grid .service-card').forEach(function (el) {
              el.setAttribute('aria-expanded', el.getAttribute('data-service') == idx ? 'true' : 'false');
            });
          }

          // Anima: esconde `from`, mostra `to` com fade+slide
          function animateSwap(from, to, afterFill) {
            if (isAnimating) return;
            isAnimating = true;

            // Fase 1: fade-out do elemento actual
            from.classList.add('sv-out');

            setTimeout(function () {
              from.hidden = true;
              from.classList.remove('sv-out');

              // Preenche conteúdo antes de mostrar
              if (afterFill) afterFill();

              // Fase 2: mostra novo elemento já "fora" (opaco 0)
              to.hidden = false;
              to.setAttribute('aria-hidden', 'false');
              to.classList.add('sv-out');

              // Duplo rAF garante que o browser regista o estado inicial antes de animar
              requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                  to.classList.remove('sv-out');
                  setTimeout(function () { isAnimating = false; }, DURATION);
                });
              });
            }, DURATION);
          }

          // Atualiza conteúdo do painel já visível (cross-fade interno)
          function animateUpdate(idx) {
            if (isAnimating) return;
            isAnimating = true;

            openView.classList.add('sv-out');
            setTimeout(function () {
              fillPanel(idx);
              openView.classList.remove('sv-out');
              setTimeout(function () { isAnimating = false; }, DURATION);
            }, DURATION);
          }

          function openService(idx) {
            // Mesmo card já aberto → fecha
            if (idx === currentIdx && !openView.hidden) {
              closeService();
              return;
            }

            if (openView.hidden) {
              // Grid → Open
              animateSwap(grid, openView, function () { fillPanel(idx); });
            } else {
              // Open → outro card (cross-fade do painel)
              animateUpdate(idx);
            }
          }

          function closeService() {
            if (isAnimating) return;
            currentIdx = -1;
            // Open → Grid
            animateSwap(openView, grid, function () {
              openView.setAttribute('aria-hidden', 'true');
              document.querySelectorAll('#sv-grid .service-card').forEach(function (el) {
                el.setAttribute('aria-expanded', 'false');
              });
            });
          }

          // Link da homepage: /servicos#sv-0 … #sv-3 (ou ?sv=0) — abre sem animação
          function openServiceFromLocation(idx) {
            if (isAnimating) return;
            if (isNaN(idx) || idx < 0 || idx > 3 || !services[idx]) return;
            fillPanel(idx);
            grid.hidden = true;
            openView.hidden = false;
            openView.setAttribute('aria-hidden', 'false');
            grid.classList.remove('sv-out');
            openView.classList.remove('sv-out');
            isAnimating = false;
            var wrap = document.getElementById('sv-wrap');
            if (wrap) {
              requestAnimationFrame(function () {
                wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
              });
            }
          }

          function parseServiceIndexFromUrl() {
            var m = (location.hash || '').match(/^#sv-([0-3])$/);
            if (m) return parseInt(m[1], 10);
            try {
              var p = new URLSearchParams(location.search).get('sv');
              if (p !== null && /^[0-3]$/.test(p)) return parseInt(p, 10);
            } catch (e) {}
            return null;
          }

          var initialServiceIdx = parseServiceIndexFromUrl();
          if (initialServiceIdx !== null) {
            openServiceFromLocation(initialServiceIdx);
          }

          function handleCardClick(idx) {
            openService(parseInt(idx, 10));
          }

          // Eventos dos cards no grid
          document.querySelectorAll('#sv-grid .service-card').forEach(function (card) {
            card.addEventListener('click', function () {
              handleCardClick(card.getAttribute('data-service'));
            });
          });

          if (closeBtn) closeBtn.addEventListener('click', closeService);

          document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && !openView.hidden) closeService();
          });
        }());

        // ---- Modal de contacto ----
        (function () {
          function contactModalEl() {
            return document.getElementById('contact-modal');
          }

          function eventTargetElement(t) {
            return t && t.nodeType === Node.ELEMENT_NODE ? t : t.parentElement;
          }

          function openModal(modal) {
            modal.removeAttribute('hidden');
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                modal.classList.add('is-open');
                modal.setAttribute('aria-hidden', 'false');
                document.body.classList.add('contact-modal-open');
                var firstField = modal.querySelector(
                  '.contact-modal-form input, .contact-modal-form textarea'
                );
                if (firstField) {
                  firstField.focus();
                }
              });
            });
          }

          function closeModal(modal) {
            modal.classList.remove('is-open');
            modal.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('contact-modal-open');
            var dialog = modal.querySelector('.contact-modal-dialog');
            var duration = 350;
            var done = false;
            function hide() {
              if (done) {
                return;
              }
              done = true;
              modal.setAttribute('hidden', '');
            }
            if (dialog) {
              dialog.addEventListener('transitionend', function onTe(ev) {
                if (ev.propertyName !== 'opacity') {
                  return;
                }
                dialog.removeEventListener('transitionend', onTe);
                hide();
              });
            }
            setTimeout(hide, duration + 50);
          }

          // Captura=true abre antes de outros listeners (ex.: navegação com # que não foram actualizados)
          document.addEventListener(
            'click',
            function (e) {
              var el = eventTargetElement(e.target);
              var trigger = el && el.closest ? el.closest('[data-contact-modal]') : null;
              if (!trigger) {
                return;
              }
              e.preventDefault();
              e.stopPropagation();
              var modalNow = contactModalEl();
              if (!modalNow) {
                return;
              }
              openModal(modalNow);
            },
            true
          );

          var modal = contactModalEl();
          if (!modal) {
            return;
          }

          modal.addEventListener('click', function (e) {
            var el = eventTargetElement(e.target);
            if (el && el.closest && el.closest('[data-contact-modal-close]')) {
              closeModal(modal);
            }
          });

          document.addEventListener('keydown', function (e) {
            var m = contactModalEl();
            if (!m) {
              return;
            }
            if (e.key === 'Escape' && m.classList.contains('is-open')) {
              closeModal(m);
            }
          });
        }());

        // ---- Mobile nav toggle ----
        var $toggle  = $('.header-toggle');
        var $panel   = $('#nav-mobile');
        var $overlay = $('#nav-mobile-overlay');

        function openNav() {
          $toggle.addClass('is-open').attr('aria-expanded', 'true');
          $panel.addClass('is-open').attr('aria-hidden', 'false');
          $overlay.addClass('is-open');
          $('header.site-header').addClass('nav-is-open');
          $('body').css('overflow', 'hidden');
        }

        function closeNav() {
          $toggle.removeClass('is-open').attr('aria-expanded', 'false');
          $panel.removeClass('is-open').attr('aria-hidden', 'true');
          $overlay.removeClass('is-open');
          $('header.site-header').removeClass('nav-is-open');
          $('body').css('overflow', '');
        }

        $toggle.on('click', function () {
          if ($toggle.hasClass('is-open')) { closeNav(); } else { openNav(); }
        });

        $overlay.on('click', closeNav);

        // Fechar ao clicar em links do painel
        $panel.find('a').on('click', closeNav);

        // Fechar com Escape
        $(document).on('keydown', function (e) {
          if (e.key === 'Escape') { closeNav(); }
        });
      },
      finalize: function() {
        jQuery('#accordion .btn-link:first').attr("aria-expanded","true");
        jQuery('#accordion .body-c:first').addClass('show');

        /* START SELECT 2! */
        function formatState (state) {
          if (!state.id || !$(state.element).attr('data-iconurl')) {
            return state.text;
          }
          var iconUrl = $(state.element).attr('data-iconurl');
          var baseUrl = iconUrl;
          var $state = $(
            '<span><img src="' + baseUrl + '" class="img-flag" width="22px" style="margin-right: 20px;"/> ' + state.text + '</span>'
            );
          return $state;
        }
        
        $(".js-select2").select2({
          minimumResultsForSearch: Infinity,
          templateResult: formatState
        }).on('select2:open', function(e){
          setTimeout(function(){ 
            $('.select2-dropdown').addClass('opened');
          }, 200);
        }).on('select2:closing', function(e){
          // if removed, for some examples, the Select2 will not highlight the selected element
          $('.select2-dropdown').removeClass('opened');
        });
        /* END SELECT 2! */
        
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS

/*
        jQuery(document).ready(function(){
         jQuery(window).on("scroll",function() {
          if(jQuery(this).scrollTop() > 50) 
            jQuery("header").addClass("scroll");
          else 
          jQuery("header").removeClass("scroll");
        })
       })
       */

          /*MENU MOBILE*/
        $('.burger-container, .nav-menu-mobile a, a.button.gradient.white-bg').on('click', function (e) {
          $('header.header').toggleClass('menu-opened');
          //$('#menu-full').fadeToggle(200);
          $('#menu-full').toggleClass('opened');
          $('.menu-bg').toggleClass('opened');
          $('body').toggleClass('over');
          $('html').toggleClass('over');
        });

        $('a.gradient.top').on('click', function (e) {
          $('header.header').removeClass('menu-opened');
          //$('#menu-full').fadeToggle(200);
          $('#menu-full').removeClass('opened');
          $('.menu-bg').removeClass('opened');
          $('body').removeClass('over');
          $('html').removeClass('over');
        });

        $('#menu-full .menu-item-has-children').on('click', function (e) {
          $(this).toggleClass('open');
          $(this).find('.sub-menu').slideToggle();
        });

        $('#menu-full div.menu ul li a.directors').on('click', function (e) {
          $('header.header').toggleClass('menu-opened');
          //$('#menu-full').fadeToggle(200);
          $('#menu-full').toggleClass('opened');
          $('.menu-bg').toggleClass('opened');
          $('body').toggleClass('over');
          $('html').toggleClass('over');
        });

      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
